const actions = {
  CONNECT: 'CONNECT',
  CONNECTING: 'CONNECTING',
  CONNECT_SUCCESS: 'CONNECT_SUCCESS',
  CONNECT_FAILED: 'CONNECT_FAILED',
  // USE THIS FOR EXAMPLE FOR DOWNLOADING REPORT OF MERCHANT
  CONNECT_MQTT: 'CONNECT_MQTT',
  DISCONNECT_MQTT: 'DISCONNECT_MQTT',
  CONNECT_MQTT_UNSUBSCRIBE_AFTER_MESSAGE_DELAY: 'CONNECT_MQTT_UNSUBSCRIBE_AFTER_MESSAGE_DELAY',
  RECEIVED_NOTIFICATION: 'RECEIVED_NOTIFICATION',
  connectMqtt: () => ({ type: actions.CONNECT }),
  disconnectMQTT: () => ({ type: actions.DISCONNECT_MQTT }),
  connectMqttForDl: payload => ({
    type: actions.CONNECT_MQTT,
    payload
  }),
  connectMqttFetchTrx: payload => ({
    type: actions.CONNECT_MQTT,
    payload
  }),
  connectMqttForUpload: payload => ({
    type: actions.CONNECT_MQTT,
    payload
  }),
  connectMqttForRedirect: payload => ({
    type: actions.CONNECT_MQTT,
    payload
  }),
  connectMqttForRefund: payload => ({
    type: actions.CONNECT_MQTT,
    payload
  }),
  connectMqttForGenerateSRFTRXReport: payload => ({
    type: actions.CONNECT_MQTT,
    payload
  }),
  connectMqttForGenerate: payload => ({
    type: actions.CONNECT_MQTT_UNSUBSCRIBE_AFTER_MESSAGE_DELAY,
    payload
  })
};
export default actions;
